export default "__VITE_ASSET__CoN8JNhV__"